import "../assets/StickyImage.css";
import { defineComponent as T, useCssVars as Z, unref as s, ref as c, computed as i, watchEffect as O, openBlock as g, createBlock as y, Transition as v, withCtx as p, withDirectives as d, createElementVNode as u, createVNode as t, vShow as m, createElementBlock as le, withModifiers as re, createCommentVNode as $, defineAsyncComponent as se, onMounted as _e, Fragment as ve, normalizeClass as J, normalizeStyle as ue, TransitionGroup as ce, provide as fe } from "vue";
import { D, f as K, e as G, a as pe, h as W } from "./maps.BERRTEN0.js";
import { u as ee } from "./index.AJuLibkw.js";
import { _ as H, i as ge } from "./XClose.vue_vue_type_style_index_0_lang.DygXUrp2.js";
import { d as de } from "./debounce.F9gDQpy6.js";
import { d as Q, n as A, t as xe, _ as ke, h as U } from "./useStore.Dhhyxhjv.js";
import { a as B, m as b, t as we } from "./useModal.CgbJKM9V.js";
import { _ as F } from "./Overlay.vue_vue_type_style_index_0_lang.C1np49Xf.js";
import { _ as R } from "./Back.vue_vue_type_style_index_0_lang.Im_9BGrj.js";
import { _ as L } from "./Steps.vue_vue_type_style_index_0_lang.BEzDKhVu.js";
import { _ as q } from "./Modal.vue_vue_type_style_index_0_lang.DoY06x2T.js";
import { _ as ye, u as Ie, a as me, i as he } from "./useImageStyles.Bf-UQWvi.js";
import { _ as ze } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { b as je } from "./Text.vue_vue_type_style_index_0_lang.D7QLYR4A.js";
import { _ as be } from "./Icon.vue_vue_type_style_index_0_lang.CFmV3COF.js";
const Ce = { class: "thn--tool-circular__content" }, Se = { class: "thn--tool-circular__popup" }, $e = 530, ho = /* @__PURE__ */ T({
  __name: "Circular",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    Z((S) => ({
      "5b80fec0": s(Q)(r.value)
    }));
    const o = de(we, 200, { leading: !0, trailing: !1 }), e = I, a = A(), n = c(!1), l = c(!1), h = c(), { width: x, height: _ } = ee(h), r = i(() => {
      const S = Math.min(x.value, _.value);
      return Math.min($e, S * 0.9);
    }), f = i(() => r.value), k = i(() => !!e.layout.closeOnClickOutside);
    O(() => {
      a == null || a.styles.addCssVariables(
        a.literals.device === D.Desktop ? {
          "--step-padding": "100px 75px 100px 60px",
          "--module-margin-top": "20px",
          "--xclose-margin": "0px"
        } : {
          "--step-padding": "70px 45px 40px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function C() {
      n.value = !1;
    }
    function j() {
      n.value = !0;
    }
    function E() {
      l.value = !0;
    }
    return z({
      show: C,
      hide: j
    }), (S, M) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: E
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-circular",
          ref_key: "rootDom",
          ref: h
        }, [
          t(F, {
            class: "thn--tool-circular__overlay",
            "close-on-click-outside": k.value
          }, null, 8, ["close-on-click-outside"]),
          u("div", Ce, [
            t(v, { name: "fade-from-bottom" }, {
              default: p(() => [
                d(u("div", Se, [
                  t(R, { class: "thn--tool-circular__back" }),
                  t(L, {
                    class: "thn--tool-circular__steps",
                    steps: e.steps,
                    "has-extra-steps": e.hasSteps,
                    "max-height": f.value
                  }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                  t(v, { name: "fade" }, {
                    default: p(() => [
                      d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                        [m, s(b)]
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [m, !n.value && l.value]
                ])
              ]),
              _: 1
            }),
            t(v, { name: "fade" }, {
              default: p(() => [
                d(t(H, null, null, 512), [
                  [m, !n.value && !s(b) && l.value]
                ])
              ]),
              _: 1
            }),
            t(v, { name: "fade" }, {
              default: p(() => [
                s(b) ? (g(), le("div", {
                  key: 0,
                  class: "thn--tool-xclose thn--tool-xclose--modal",
                  onMousedown: M[0] || (M[0] = re(
                    //@ts-ignore
                    (...w) => s(o) && s(o)(...w),
                    ["left"]
                  )),
                  onClick: M[1] || (M[1] = //@ts-ignore
                  (...w) => s(o) && s(o)(...w))
                }, [
                  t(s(ge), { class: "thn--tool-xclose__svg" })
                ], 32)) : $("", !0)
              ]),
              _: 1
            })
          ])
        ], 512), [
          [m, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), De = {
  class: "thn--tool__popup thn--tool-custom-content",
  "data-add-module": !0
}, Me = /* @__PURE__ */ T({
  __name: "CustomImage",
  props: {
    language: {},
    device: {},
    steps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(), n = c(!1), { width: l, height: h } = ee(a), x = i(() => !!o.layout.closeOnClickOutside), _ = i(() => o.steps[K.Main][0]), r = i(() => {
      if (l.value) {
        const j = (e == null ? void 0 : e.literals.device) === D.Mobile ? 0.9 : 0.8;
        return l.value * j;
      }
      return 300;
    }), f = i(() => {
      if (h.value) {
        const j = (e == null ? void 0 : e.literals.device) === D.Mobile ? 0.9 : 0.8;
        return h.value * j;
      }
      return 300;
    });
    function k() {
      n.value = !1;
    }
    function C() {
      n.value = !0;
    }
    return O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    }), z({
      show: k,
      hide: C
    }), (j, E) => (g(), y(v, {
      name: "fade",
      appear: ""
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-custom-image",
          ref_key: "rootDom",
          ref: a
        }, [
          t(F, {
            class: "thn--tool-custom-image__overlay",
            "close-on-click-outside": x.value
          }, null, 8, ["close-on-click-outside"]),
          u("div", De, [
            t(ye, {
              class: "thn--tool-custom-image__image",
              "module-props": _.value,
              "max-width": r.value,
              "max-height": f.value
            }, null, 8, ["module-props", "max-width", "max-height"]),
            t(H)
          ])
        ], 512), [
          [m, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), _o = /* @__PURE__ */ ze(Me, [["__scopeId", "data-v-9e5cb38d"]]), Ee = { class: "thn--tool-fullscreen__popup" }, vo = /* @__PURE__ */ T({
  __name: "Fullscreen",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(!1), n = c(!1), l = c(), h = i(() => {
      if (l.value)
        return l.value.offsetHeight;
    }), x = i(() => o.layout.closeOnClickOutside);
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function _() {
      a.value = !1;
    }
    function r() {
      a.value = !0;
    }
    function f() {
      n.value = !0;
    }
    return z({
      show: _,
      hide: r
    }), (k, C) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-fullscreen",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-fullscreen__overlay",
            "close-on-click-outside": !!x.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => [
              d(u("div", Ee, [
                t(L, {
                  class: "thn--tool-fullscreen__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": h.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [m, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [m, !a.value && n.value]
              ])
            ]),
            _: 1
          }),
          s(b) ? $("", !0) : (g(), y(H, { key: 0 }))
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Oe = ["data-device"], fo = /* @__PURE__ */ T({
  __name: "FullscreenMini",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(!1), n = c(!1), l = c(), h = i(() => {
      if (l.value)
        return l.value.offsetHeight;
    }), x = i(() => o.layout.closeOnClickOutside);
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": "20px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function _() {
      a.value = !1;
    }
    function r() {
      a.value = !0;
    }
    function f() {
      n.value = !0;
    }
    return z({
      show: _,
      hide: r
    }), (k, C) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-fullscreen-mini",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-fullscreen-mini__overlay",
            "close-on-click-outside": !!x.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => {
              var j;
              return [
                d(u("div", {
                  class: "thn--tool-fullscreen-mini__popup",
                  "data-device": (j = s(e)) == null ? void 0 : j.literals.device
                }, [
                  t(L, {
                    class: "thn--tool-fullscreen-mini__steps",
                    steps: o.steps,
                    "has-extra-steps": o.hasSteps,
                    "max-height": h.value
                  }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                  t(v, { name: "fade" }, {
                    default: p(() => [
                      d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                        [m, s(b)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, Oe), [
                  [m, !a.value && n.value]
                ])
              ];
            }),
            _: 1
          }),
          s(b) ? $("", !0) : (g(), y(H, { key: 0 }))
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Te = ["data-device"], go = /* @__PURE__ */ T({
  __name: "LowerNotification",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(!1), n = c(), l = i(() => (e == null ? void 0 : e.handlers.stepActive) || K.Main), h = i(() => (e == null ? void 0 : e.literals.device) === D.Mobile), x = i(() => o.steps[K.Main].filter(
      (S) => S.moduleType !== G.Icon
    ).length), _ = i(() => o.steps[K.Main].find(
      (S) => S.moduleType === G.Icon
    )), r = i(() => o.steps[l.value].find(
      (S) => S.moduleType === G.Button
    )), f = i(() => !!o.steps[K.Main].find(
      (S) => S.moduleType === G.Form
    )), k = i(() => Object.keys(o.steps).reduce((M, w) => (M[w] = o.steps[w].filter(
      (N) => N.moduleType !== G.Icon && N.moduleType !== G.Button || N.moduleType !== G.Icon && x.value > 4 || N.moduleType !== G.Icon && f.value || h.value
    ), M), {})), C = i(() => {
      if (n.value)
        return h.value ? 0 : 270;
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        h.value ? {
          "--step-padding": "5px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--module-margin-top": "10px",
          "--step-padding": `5px 15px 10px ${_.value ? 20 : 0}px`,
          "--xclose-margin": "7px"
        }
      );
    });
    function j() {
      a.value = !1;
    }
    function E() {
      a.value = !0;
    }
    return z({
      show: j,
      hide: E
    }), (S, M) => (g(), y(v, {
      name: "fade-from-bottom",
      appear: ""
    }, {
      default: p(() => {
        var w;
        return [
          d(u("div", {
            class: "thn--tool-lower-notification",
            ref_key: "rootDom",
            ref: n
          }, [
            u("div", {
              class: "thn--tool-lower-notification__popup",
              "data-device": (w = s(e)) == null ? void 0 : w.literals.device
            }, [
              t(R, { class: "thn--tool-lower-notification__back" }),
              _.value && !h.value ? (g(), y(be, {
                key: 0,
                class: "thn--tool-lower-notification__icon",
                "module-props": _.value
              }, null, 8, ["module-props"])) : $("", !0),
              t(L, {
                class: "thn--tool-lower-notification__steps",
                steps: k.value,
                "has-extra-steps": o.hasSteps,
                "max-height": C.value,
                "layout-kind": s(pe).LowerNotification
              }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind"]),
              r.value && !h.value && x.value <= 4 && !f.value ? (g(), y(je, {
                key: 1,
                class: "thn--tool-lower-notification__button",
                "module-props": r.value,
                "has-extra-steps": o.hasSteps,
                "data-module-id": r.value.id,
                "data-module-special": !0
              }, null, 8, ["module-props", "has-extra-steps", "data-module-id"])) : $("", !0),
              s(b) ? $("", !0) : (g(), y(H, {
                key: 2,
                class: "thn--tool-lower-notification__xclose"
              })),
              t(v, { name: "fade" }, {
                default: p(() => [
                  d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                    [m, s(b)]
                  ])
                ]),
                _: 1
              })
            ], 8, Te)
          ], 512), [
            [m, !a.value]
          ])
        ];
      }),
      _: 1
    }));
  }
}), He = ["data-position"], Ae = ["data-closed"], Pe = ["data-show-number", "disabled"], ne = 40, ae = 0.6, ie = 620, xo = /* @__PURE__ */ T({
  __name: "NotificationTab",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  emits: [
    "after-leave"
  ],
  setup(I, { expose: z, emit: o }) {
    Z((P) => ({
      "7deccd74": s(Q)(ne),
      "61c09fd2": s(Q)(E.value)
    }));
    const e = I, a = o, n = c(!0), l = c(), { width: h, height: x } = ee(l), _ = A(), r = c(!1), f = i(() => {
      var P;
      return ((P = e.layout.position) == null ? void 0 : P.charAt(0)) === "L";
    }), k = i(() => {
      var P;
      if ((P = e.layout.icon) != null && P.value) {
        const X = `${xe(e.layout.icon.value)}Icon`;
        return se(() => ke(/* @__PURE__ */ Object.assign({ "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidAppleIcon.js": () => import("./AndroidAppleIcon.Ce3m-x9g.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidIcon.js": () => import("./AndroidIcon.D59wfG9g.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AppleIcon.js": () => import("./AppleIcon.BqnkkuKL.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AutumnIcon.js": () => import("./AutumnIcon.CSxJz0UO.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BabyBottleIcon.js": () => import("./BabyBottleIcon.Ba9ICO6D.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BaliBedIcon.js": () => import("./BaliBedIcon.CtKvYP2x.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BathtubIcon.js": () => import("./BathtubIcon.BsN_f94d.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeachballIcon.js": () => import("./BeachballIcon.CGxH3w1e.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeerIcon.js": () => import("./BeerIcon.JgpY0O9A.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BellIcon.js": () => import("./BellIcon.D6Uir9XB.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BicycleIcon.js": () => import("./BicycleIcon.C09WLIqu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BikeIcon.js": () => import("./BikeIcon.D9eOeJg8.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BinocularsIcon.js": () => import("./BinocularsIcon.Bk2G58hY.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BoatIcon.js": () => import("./BoatIcon.DWyXsPwt.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/Book2Icon.js": () => import("./Book2Icon.C-4bP1KQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BookIcon.js": () => import("./BookIcon.DkmG6OCP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BreadIcon.js": () => import("./BreadIcon.ClpRBAXL.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BriefcaseIcon.js": () => import("./BriefcaseIcon.BJbaUrDS.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusIcon.js": () => import("./BusIcon.BU_u6QxI.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusNewIcon.js": () => import("./BusNewIcon.Cilr6kAF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BycicleIcon.js": () => import("./BycicleIcon.BZBVJWTk.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CactusIcon.js": () => import("./CactusIcon.BStXXFwi.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CakeIcon.js": () => import("./CakeIcon.DvQFC2Cu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CalendarIcon.js": () => import("./CalendarIcon.BCTm2dSH.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CameraIcon.js": () => import("./CameraIcon.D0M6m-Ea.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarIcon.js": () => import("./CarIcon.BN_V6OW_.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarNewIcon.js": () => import("./CarNewIcon.CYgdMbhR.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarrotIcon.js": () => import("./CarrotIcon.B-LbpgkZ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CheckIcon.js": () => import("./CheckIcon.CcHVV6hy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ChurchIcon.js": () => import("./ChurchIcon.D9b_dCWf.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ClockIcon.js": () => import("./ClockIcon.BWEPz_Hy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CocktailIcon.js": () => import("./CocktailIcon.XOV-0WDH.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CoffeeIcon.js": () => import("./CoffeeIcon.D5evvPd9.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CupsIcon.js": () => import("./CupsIcon.qUhdioKA.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DangerIcon.js": () => import("./DangerIcon.DT2DUSUq.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DiscountIcon.js": () => import("./DiscountIcon.XPTy3zJl.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DownloadMobileIcon.js": () => import("./DownloadMobileIcon.CTVj4YnV.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/EggIcon.js": () => import("./EggIcon.gJR9gPWC.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/EnvelopeIcon.js": () => import("./EnvelopeIcon.DaxFQToj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FacebookIcon.js": () => import("./FacebookIcon.T-tX6GjS.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FamilyIcon.js": () => import("./FamilyIcon.aFJH10rD.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FlipFlopsIcon.js": () => import("./FlipFlopsIcon.eBjVztuk.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GhostIcon.js": () => import("./GhostIcon.C8_Nbvg5.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GiftIcon.js": () => import("./GiftIcon.DpdbfXCQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GolfIcon.js": () => import("./GolfIcon.DlLqrVf5.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphIcon.js": () => import("./GraphIcon.DFo4J-S-.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphUpIcon.js": () => import("./GraphUpIcon.DcPLofhe.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GymIcon.js": () => import("./GymIcon.-rHYS7-S.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HalloweenIcon.js": () => import("./HalloweenIcon.BKPA3FNw.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HamburgerIcon.js": () => import("./HamburgerIcon.Cc3QkvuN.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HandShakeIcon.js": () => import("./HandShakeIcon.Bz6Ol0vW.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HashtagIcon.js": () => import("./HashtagIcon.Bcj0HGjz.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartIcon.js": () => import("./HeartIcon.BW1FSriv.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsIcon.js": () => import("./HeartsIcon.D3fMAQux.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsNewIcon.js": () => import("./HeartsNewIcon.Zioj2TFF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HotelIcon.js": () => import("./HotelIcon.B5Qba7M6.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/InformationIcon.js": () => import("./InformationIcon.DOXGspCQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/InstagramIcon.js": () => import("./InstagramIcon.BYzpKAQv.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastReservationIcon.js": () => import("./LastReservationIcon.Bp8te3ka.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastWeekStayedIcon.js": () => import("./LastWeekStayedIcon.DJ7NhwBI.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LaundryIcon.js": () => import("./LaundryIcon.COSYLGm1.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LightIcon.js": () => import("./LightIcon.D2dFJ8Qs.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LockGreatPriceIcon.js": () => import("./LockGreatPriceIcon.0ZJ_H9Jy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/MaskIcon.js": () => import("./MaskIcon.D6OtYUfw.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/MusicIcon.js": () => import("./MusicIcon.Dc6x9kQB.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PalmIcon.js": () => import("./PalmIcon.Bv-PS4bP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingCarIcon.js": () => import("./ParkingCarIcon.DiLVMG51.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingPIcon.js": () => import("./ParkingPIcon.BBA1vmyV.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PawIcon.js": () => import("./PawIcon.DIYsPJ4E.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PictureIcon.js": () => import("./PictureIcon.ByEUCyAF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PinIcon.js": () => import("./PinIcon._FIrbnqm.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PizzaIcon.js": () => import("./PizzaIcon.DfPPGTtP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlaneIcon.js": () => import("./PlaneIcon.CA12HAqM.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlatterIcon.js": () => import("./PlatterIcon.CRNnpxMQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PoolIcon.js": () => import("./PoolIcon.Dd1_K1lp.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PrizeIcon.js": () => import("./PrizeIcon.CEmq9FRR.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RabbitIcon.js": () => import("./RabbitIcon.CeQLI7M2.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RaceIcon.js": () => import("./RaceIcon.DMEMTBQu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RelaxIcon.js": () => import("./RelaxIcon.Di7AsJ5h.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RestaurantIcon.js": () => import("./RestaurantIcon.Df5nw0MC.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ReviewsIcon.js": () => import("./ReviewsIcon.CVUG9v_F.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoomIcon.js": () => import("./RoomIcon.BBygCFIz.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoseIcon.js": () => import("./RoseIcon.DyPxzQvx.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SantaIcon.js": () => import("./SantaIcon.BWe78Ox_.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceDollarIcon.js": () => import("./SecurePriceDollarIcon.Ch4mkbEo.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceEuroIcon.js": () => import("./SecurePriceEuroIcon.YtJ-VehJ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceIcon.js": () => import("./SecurePriceIcon.Ch4mkbEo.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePricePoundIcon.js": () => import("./SecurePricePoundIcon.Bq7uH4TE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceYenIcon.js": () => import("./SecurePriceYenIcon.Dk_E6xFN.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ShoppingIcon.js": () => import("./ShoppingIcon.8dtsN1cd.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SkiIcon.js": () => import("./SkiIcon.C2zs3hk3.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SnowIcon.js": () => import("./SnowIcon.Bn1T00xF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpacerIcon.js": () => import("./SpacerIcon.-A9pCNqE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpecialIcon.js": () => import("./SpecialIcon.B6TeHwGZ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/StarIcon.js": () => import("./StarIcon.BdVMO6nj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SunIcon.js": () => import("./SunIcon.BBk_bORh.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SurfIcon.js": () => import("./SurfIcon.ajX4djVO.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ThunderIcon.js": () => import("./ThunderIcon.6k9RC-uG.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TieIcon.js": () => import("./TieIcon.8ACySmda.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TreeIcon.js": () => import("./TreeIcon.BhM-3ef4.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TripadvisorIcon.js": () => import("./TripadvisorIcon.D7p7JPED.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TrophyIcon.js": () => import("./TrophyIcon.BQMBJ0cE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TvIcon.js": () => import("./TvIcon.DP_1G6Et.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UserIcon.js": () => import("./UserIcon.D7iosg3a.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersIcon.js": () => import("./UsersIcon.BORnyKHZ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersNewIcon.js": () => import("./UsersNewIcon.Crg4GRbQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/VirusIcon.js": () => import("./VirusIcon.DgltyNxg.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/VoucherIcon.js": () => import("./VoucherIcon.8Hc1prKP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WeddingIcon.js": () => import("./WeddingIcon.C7ZLkflB.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WhatsappIcon.js": () => import("./WhatsappIcon.DpQSm_yX.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WheelchairIcon.js": () => import("./WheelchairIcon.DtoQNway.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WifiIcon.js": () => import("./WifiIcon.BCdEhEpK.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WineIcon.js": () => import("./WineIcon.3-I6YBP1.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/index.js": () => import("./index.BaCRT2hI.js") }), `../../node_modules/@thehotelsnetwork/icons/vue/personalization/${X}.js`, 8));
      }
      return null;
    }), C = i(() => se(() => f.value ? import("./ChevronDownIcon.BjrxvU4d.js") : import("./ChevronUpIcon.Dnr2MR6B.js")));
    O(() => {
      _ == null || _.styles.addCssVariables(
        _.literals.device === D.Desktop ? {
          "--step-padding": "32px 45px 32px 32px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px 40px 25px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    const j = i(() => e.layout.position === "UML" || e.layout.position === "UMR" || e.layout.position === "LML" || e.layout.position === "LMR"), E = i(() => h.value ? h.value - 2 * ne : 0), S = i(() => x.value && j.value ? x.value * ae : x.value ? x.value > ie ? ie : x.value * ae : 0), M = i(() => {
      let P = "up";
      return (f.value && n.value || !f.value && !n.value) && (P = "down"), `fade-tab-icon-${P}`;
    });
    function w() {
      n.value = !1;
    }
    function N() {
      n.value = !0, a("after-leave");
    }
    const V = de(() => {
      n.value = !n.value;
    }, 200, { leading: !0, trailing: !1 });
    function oe() {
      r.value = !0;
    }
    return O(() => {
      _ != null && _.extraData.builderMode && setTimeout(() => {
        n.value = !1;
      }, 500);
    }), _e(() => {
      e.layout.showOpen && setTimeout(() => {
        n.value = !1;
      }, 1e3);
    }), z({
      show: w,
      hide: N
    }), (P, X) => {
      var te;
      return g(), le(ve, null, [
        u("div", {
          class: "thn--tool-notification-tab__sizer",
          ref_key: "sizerDom",
          ref: l
        }, null, 512),
        u("div", {
          class: "thn--tool-notification-tab",
          "data-position": P.layout.position
        }, [
          u("div", {
            class: "thn--tool-notification-tab__popup",
            "data-closed": n.value
          }, [
            t(R, { class: "thn--tool-notification-tab__back" }),
            t(L, {
              class: "thn--tool-notification-tab__steps",
              steps: e.steps,
              "has-extra-steps": e.hasSteps,
              "max-height": S.value
            }, null, 8, ["steps", "has-extra-steps", "max-height"]),
            t(H, {
              "trigger-dismiss": !1,
              onMousedown: re(s(V), ["left"]),
              onClick: s(V)
            }, null, 8, ["onMousedown", "onClick"]),
            t(v, {
              name: "fade",
              appear: "",
              onAfterEnter: oe
            }, {
              default: p(() => [
                d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                  [m, s(b)]
                ])
              ]),
              _: 1
            })
          ], 8, Ae),
          u("div", {
            class: "thn--tool-notification-tab__tab",
            onClick: X[0] || (X[0] = //@ts-ignore
            (...Y) => s(V) && s(V)(...Y)),
            "data-show-number": n.value,
            disabled: (te = s(_)) == null ? void 0 : te.extraData.builderMode
          }, [
            t(v, { name: M.value }, {
              default: p(() => {
                var Y;
                return [
                  n.value || (Y = s(_)) != null && Y.extraData.builderMode ? (g(), y(s(k), {
                    key: 0,
                    class: "thn--tool-notification-tab__icon"
                  })) : n.value ? $("", !0) : (g(), y(s(C), {
                    key: 1,
                    class: "thn--tool-notification-tab__icon"
                  }))
                ];
              }),
              _: 1
            }, 8, ["name"])
          ], 8, Pe)
        ], 8, He)
      ], 64);
    };
  }
}), Be = ["data-layout-position", "data-size", "data-device"], ko = /* @__PURE__ */ T({
  __name: "Sidebar",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(!1), n = c(!1), l = c(), h = c(), x = i(() => {
      if (l.value) {
        const j = o.layout.position === W.Bottom ? 0.5 : 1;
        return l.value.offsetHeight * j;
      }
    }), _ = i(() => o.layout.closeOnClickOutside), r = i(() => {
      switch (o.layout.position) {
        case W.Left:
          return "fade-from-left";
        case W.Right:
          return "fade-from-right";
        case W.Bottom:
        default:
          return "fade-from-bottom";
      }
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function f() {
      a.value = !1;
    }
    function k() {
      a.value = !0;
    }
    function C() {
      n.value = !0;
    }
    return z({
      show: f,
      hide: k
    }), (j, E) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: C
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-sidebar",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-sidebar__overlay",
            "close-on-click-outside": !!_.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: r.value }, {
            default: p(() => [
              d(u("div", {
                class: "thn--tool-sidebar__popup",
                ref_key: "popupDom",
                ref: h,
                "data-layout-position": o.layout.position,
                "data-size": o.layout.size,
                "data-device": o.device
              }, [
                t(R, { class: "thn--tool-sidebar__back" }),
                t(L, {
                  class: "thn--tool-sidebar__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": x.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(b) ? $("", !0) : (g(), y(H, { key: 0 })),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [m, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Be), [
                [m, !a.value && n.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Le = ["data-size", "data-position"], qe = { class: "thn--tool-side-gradient__content" }, wo = /* @__PURE__ */ T({
  __name: "SideGradient",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    Z((r) => ({
      a8d7e3ec: h.value
    }));
    const o = I, e = A(), a = c(!1), n = c(), l = i(() => {
      if (n.value) {
        const r = o.layout.position === W.Bottom ? 0.5 : 1;
        return n.value.offsetHeight * r;
      }
    }), h = i(() => {
      const {
        base: r = "#ffffff",
        gradient: f
      } = (e == null ? void 0 : e.styles.colors.background) || {};
      let k;
      switch (o.layout.position) {
        case W.Bottom:
          k = 360;
          break;
        case W.Right:
          k = -90;
          break;
        default:
          k = 90;
          break;
      }
      const C = e != null && e.rtl && o.layout.position !== W.Bottom ? `${U(f || r, 0)} 0%, 
       ${U(f || r, 0.75)} 41.36%, 
       ${U(r, 0.95)} 71.2%, 
       ${r} 99.93%` : `${r} 0.07%, 
       ${U(r, 0.95)} 28.8%, 
       ${U(f || r, 0.75)} 58.64%, 
       ${U(f || r, 0)} 100%`;
      return `linear-gradient(${k}deg, ${C})`;
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function x() {
      a.value = !1;
    }
    function _() {
      a.value = !0;
    }
    return z({
      show: x,
      hide: _
    }), (r, f) => (g(), y(v, {
      name: "fade",
      appear: ""
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-side-gradient",
          ref_key: "rootDom",
          ref: n
        }, [
          u("div", {
            class: "thn--tool-side-gradient__popup",
            "data-size": o.layout.size,
            "data-position": o.layout.position
          }, [
            u("div", qe, [
              t(L, {
                class: "thn--tool-side-gradient__steps",
                steps: o.steps,
                "has-extra-steps": o.hasSteps,
                "max-height": l.value,
                layout: o.layout
              }, null, 8, ["steps", "has-extra-steps", "max-height", "layout"]),
              s(b) ? $("", !0) : (g(), y(H, {
                key: 0,
                class: "thn--tool-side-gradient__xclose"
              })),
              t(v, { name: "fade" }, {
                default: p(() => [
                  d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                    [m, s(b)]
                  ])
                ]),
                _: 1
              })
            ])
          ], 8, Le)
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ve = { class: "thn--tool-square__popup" }, yo = /* @__PURE__ */ T({
  __name: "Square",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(!1), n = c(!1), l = c(), h = i(() => {
      if (l.value)
        return l.value.offsetHeight * 0.8;
    }), x = i(() => !!o.layout.closeOnClickOutside);
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function _() {
      a.value = !1;
    }
    function r() {
      a.value = !0;
    }
    function f() {
      n.value = !0;
    }
    return z({
      show: _,
      hide: r
    }), (k, C) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-square",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-square__overlay",
            "close-on-click-outside": x.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => [
              d(u("div", Ve, [
                t(R, { class: "thn--tool-square__back" }),
                t(L, {
                  class: "thn--tool-square__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": h.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(b) ? $("", !0) : (g(), y(H, { key: 0 })),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [m, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [m, !a.value && n.value]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Re = ["data-loaded"], Ne = ["src", "alt"], Ge = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, Io = /* @__PURE__ */ T({
  __name: "SquareImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = A(), e = I, a = c(), n = c(!1), l = c(!1), h = c(!1), x = i(() => e.layout), _ = i(() => e.device), { imageUrl: r, imageAlt: f } = Ie(x, _), k = i(() => {
      if (a.value) {
        const V = e.device === D.Mobile ? 0.4 : 0.8;
        return a.value.offsetHeight * V;
      }
    }), C = i(() => !!e.layout.closeOnClickOutside), j = i(() => {
      var V;
      return e.device === D.Mobile ? "top" : ((V = e.layout) == null ? void 0 : V.imagePosition) ?? "left";
    }), { imageStyles: E } = me(
      i(() => e.layout),
      i(() => e.device),
      j
    );
    O(() => {
      o == null || o.styles.addCssVariables(
        o.literals.device === D.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      ), r.value || (n.value = !1);
    });
    function S() {
      l.value = !1;
    }
    function M() {
      l.value = !0;
    }
    function w() {
      h.value = !0;
    }
    function N() {
      n.value = !0;
    }
    return z({
      show: S,
      hide: M
    }), (V, oe) => (g(), y(v, {
      name: "fade",
      onAfterEnter: w,
      appear: ""
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-square-image",
          ref_key: "rootDom",
          ref: a
        }, [
          t(F, {
            class: "thn--tool-square-image__overlay",
            "close-on-click-outside": C.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => [
              d(u("div", {
                class: J([
                  "thn--tool-square-image__popup",
                  j.value
                ])
              }, [
                s(E) ? (g(), y(R, {
                  key: 0,
                  class: "thn--tool-square-image__back"
                })) : $("", !0),
                u("div", {
                  class: J([
                    "thn--tool-square-image__popup__wrapper",
                    j.value
                  ])
                }, [
                  u("div", {
                    class: "thn--tool-square-image__image",
                    style: ue(s(E)),
                    "data-loaded": n.value
                  }, [
                    t(ce, { name: "fade" }, {
                      default: p(() => [
                        d(u("img", {
                          ref: "imageDOM",
                          src: s(r),
                          onLoad: N,
                          alt: s(f)
                        }, null, 40, Ne), [
                          [m, n.value]
                        ]),
                        d(u("div", Ge, [
                          t(s(he), { class: "img-icon" })
                        ], 512), [
                          [m, !n.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 12, Re),
                  u("div", {
                    class: J(["thn--tool-square-image__content", [{ relative: n.value }]])
                  }, [
                    s(E) ? $("", !0) : (g(), y(R, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })),
                    t(L, {
                      class: "thn--tool-square-image__steps",
                      steps: e.steps,
                      "has-extra-steps": e.hasSteps,
                      "max-height": k.value,
                      "layout-kind": s(pe).SquareImage
                    }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind"])
                  ], 2),
                  s(b) ? $("", !0) : (g(), y(H, { key: 0 })),
                  t(v, { name: "fade" }, {
                    default: p(() => [
                      d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                        [m, s(b)]
                      ])
                    ]),
                    _: 1
                  })
                ], 2)
              ], 2), [
                [m, !l.value && h.value]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [m, !l.value]
        ])
      ]),
      _: 1
    }));
  }
}), We = ["data-position", "data-size"], zo = /* @__PURE__ */ T({
  __name: "Sticky",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = A(), a = c(!1), n = c(!1), l = c(), h = i(() => {
      if (l.value)
        return l.value.offsetHeight * 0.6;
    });
    i(() => !!o.layout.closeOnClickOutside);
    const x = i(() => {
      const { position: k } = o.layout;
      return k ? `fade-from-${k.slice(-1) === "L" ? "left" : "right"}` : "fade";
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": "24px 40px 24px 24px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": "24px 40px 24px 24px",
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      );
    });
    function _() {
      a.value = !1;
    }
    function r() {
      a.value = !0;
    }
    function f() {
      n.value = !0;
    }
    return z({
      show: _,
      hide: r
    }), (k, C) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: f
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-sticky",
          ref_key: "rootDom",
          ref: l
        }, [
          t(v, { name: x.value }, {
            default: p(() => [
              d(u("div", {
                class: "thn--tool-sticky__popup",
                "data-position": k.layout.position,
                "data-size": o.layout.size
              }, [
                t(R, { class: "thn--tool-sticky__back" }),
                t(L, {
                  class: "thn--tool-sticky__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": h.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(b) ? $("", !0) : (g(), y(H, { key: 0 })),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [m, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, We), [
                [m, !a.value && n.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
}), Fe = ["data-device", "data-position", "data-size", "data-image-position"], Ue = { class: "thn--tool-sticky-image__popup__wrapper" }, Ke = ["data-loaded"], Xe = ["src", "alt"], Ye = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, jo = /* @__PURE__ */ T({
  __name: "StickyImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I;
    fe("layout", c(o.layout));
    const e = A(), a = c(!1), n = c(!1), l = c(!1), h = c(), x = i(() => {
      var w;
      return (w = o.layout) != null && w.image ? e == null ? void 0 : e.literals.getLocaleImageUrl(o.layout.image) : "";
    }), _ = i(() => {
      var w;
      return (w = o.layout) != null && w.image ? e == null ? void 0 : e.literals.getLocaleImageAlt(o.layout.image) : "";
    }), r = i(() => {
      if (h.value)
        return h.value.offsetHeight * 0.6;
    }), f = i(() => {
      const { position: w } = o.layout;
      return w ? `fade-from-${w.slice(-1) === "L" ? "left" : "right"}` : "fade";
    }), k = i(() => {
      var w;
      return ((w = o.layout) == null ? void 0 : w.imagePosition) ?? "left";
    }), { imageStyles: C } = me(
      i(() => o.layout),
      i(() => o.device),
      k
    );
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === D.Desktop ? {
          "--step-padding": `16px ${k.value === "left" ? "40px" : "16px"} 16px 16px`,
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": `16px ${k.value === "left" ? "40px" : "16px"} 16px 16px`,
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      ), x.value || (n.value = !1);
    });
    function j() {
      a.value = !1;
    }
    function E() {
      a.value = !0;
    }
    function S() {
      l.value = !0;
    }
    function M() {
      n.value = !0;
    }
    return z({
      show: j,
      hide: E
    }), (w, N) => (g(), y(v, {
      name: "fade",
      appear: "",
      onAfterEnter: S
    }, {
      default: p(() => [
        d(u("div", {
          class: "thn--tool-sticky-image",
          ref_key: "rootDom",
          ref: h
        }, [
          t(v, { name: f.value }, {
            default: p(() => [
              d(u("div", {
                class: "thn--tool-sticky-image__popup",
                "data-device": w.device,
                "data-position": w.layout.position,
                "data-size": o.layout.size,
                "data-image-position": k.value
              }, [
                u("div", Ue, [
                  s(C) ? (g(), y(R, {
                    key: 0,
                    class: "thn--tool-square-image__back"
                  })) : $("", !0),
                  u("div", {
                    class: "thn--tool-sticky-image__image",
                    style: ue(s(C)),
                    "data-loaded": n.value
                  }, [
                    t(ce, { name: "fade" }, {
                      default: p(() => [
                        d(u("img", {
                          ref: "imageDOM",
                          src: x.value,
                          onLoad: M,
                          alt: _.value
                        }, null, 40, Xe), [
                          [m, n.value]
                        ]),
                        d(u("div", Ye, [
                          t(s(he), { class: "img-icon" })
                        ], 512), [
                          [m, !n.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 12, Ke),
                  u("div", {
                    class: J(["thn--tool-sticky-image__content", [{ relative: n.value }]])
                  }, [
                    s(C) ? $("", !0) : (g(), y(R, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })),
                    t(L, {
                      class: "thn--tool-sticky-image__steps",
                      steps: o.steps,
                      "has-extra-steps": o.hasSteps,
                      "max-height": r.value
                    }, null, 8, ["steps", "has-extra-steps", "max-height"])
                  ], 2),
                  s(b) ? $("", !0) : (g(), y(H, { key: 1 }))
                ]),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    d(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [m, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Fe), [
                [m, !a.value && l.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [m, !a.value]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  _o as C,
  ho as _,
  vo as a,
  fo as b,
  go as c,
  xo as d,
  ko as e,
  wo as f,
  yo as g,
  Io as h,
  zo as i,
  jo as j
};
//# sourceMappingURL=StickyImage.vue_vue_type_style_index_0_lang.C2SMhFPM.js.map
